import { useEffect, useLayoutEffect, useState } from 'react';
import { useModalStore } from '@/entities/Modal';
import { Story } from '../model/types';
import { STORIES_MAP } from '../model/data';
import { StoriesModal } from './StoriesModal';
import { MiniStoriesList } from './MiniStoriesList';
import { preloadStories } from '../lib/preloadStories';
import cls from './Stories.module.scss';

export const Stories = () => {
    const { setIsStoriesModalOpen } = useModalStore();
    const [stories, setStories] = useState<Story[]>([]);
    const [watchedStoriesIds, setWatchedStoriesIds] = useState<Set<number>>(new Set());

    useLayoutEffect(() => {
        const watchedStories = localStorage.getItem('watchedStoriesIds');

        if (watchedStories) {
            const parsedIds: number[] = JSON.parse(watchedStories);
            const set = new Set<number>(parsedIds);

            setWatchedStoriesIds(set);
        }
    }, []);

    useEffect(() => {
        preloadStories();
    }, []);

    const onStoryClick = (id: number) => {
        setStories(STORIES_MAP.get(id)!);
        setIsStoriesModalOpen(true);

        const ids = new Set([id, ...watchedStoriesIds]);

        setWatchedStoriesIds(ids);

        localStorage.setItem('watchedStoriesIds', JSON.stringify([...ids]));
    };

    return (
        <article className={cls.container}>
            <MiniStoriesList watchedStoriesIds={watchedStoriesIds} onStoryClick={onStoryClick} />
            <StoriesModal stories={stories} />
        </article>
    );
};
